import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import modules from './modules';

import chat from './modules/chat';

export default {
  namespaced: true,
  state,
  actions: { ...actions, ...chat.actions },
  mutations: { ...mutations, ...chat.mutations },
  getters,
  modules,
};
